export const NOTIFICATION_PREFERENCES_TABLE_CLASS_NAMES = {
  card: {
    container: 'h-full w-full overflow-x-auto max-h-full max-w-[calc(100%)] overflow-x-auto',
    content: 'p-0 m-2 overflow-y-hidden max-h-full',
  },
  table: {
    container: 'overflow-auto h-full w-full sticky top-0  min-h-[calc(100vh-15.8rem)] max-h-[calc(100vh-15.8rem)]',
    th: '[&>*]:text-left [&>*]:text-subtext [&>*]:font-medium [&>*]:text-[14px] py-2',
    tr: 'h-14 bg-white',
    td: 'group-hover:bg-gray-100',
  },
};
